import { FormBuilder, FormGroup } from '@angular/forms';
import { MyElContrattiUsati, MyElContrattiUsatiSociLavoratori, MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { CoopValidators } from '@core/helpers/validators.helper';
import { rebuildFormArray } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const buildContrattiUsatiSociLavoratoriFormArray = (fb: FormBuilder, myVerbale: MyVerbale, form: FormGroup) => {
    const contrattiUsatiSociLavoratori = myVerbale?.my_SezioneI__Rilevazione?.my_EffettivitaBaseSociale?.my_ContrattiUsatiSociLavoratori?.my_ElContrattiUsatiSociLavoratori;
    rebuildFormArray(
        fb,
        contrattiUsatiSociLavoratori,
        form,
        `${formPaths.baseSociale}.my_ContrattiUsatiSociLavoratori.my_ElContrattiUsatiSociLavoratori`,
        buildContrattiUsatiSociLavoratoriGroup
    );
};

export const buildContrattiUsatiSociLavoratoriGroup = (fb: FormBuilder, item?: MyElContrattiUsatiSociLavoratori): FormGroup => {
    return fb.group({
        my_ContrattiUsatiSociLavoratoriDescNome: item?.my_ContrattiUsatiSociLavoratoriDescNome ?? '',
        my_ContrattiUsatiSociLavoratoriDesc: item?.my_ContrattiUsatiSociLavoratoriDesc ?? '',
        my_group61: item?.my_group61,
    });
};

export const buildContrattiSociFormArray = (fb: FormBuilder, myVerbale: MyVerbale, form: FormGroup) => {
    const my_ElContrattiUsati = myVerbale?.my_SezioneI__Rilevazione?.my_EffettivitaBaseSociale?.my_ContrattiUsati?.my_ElContrattiUsati;
    rebuildFormArray(fb, my_ElContrattiUsati, form, `${formPaths.baseSociale}.my_ContrattiUsati.my_ElContrattiUsati`, buildContrattiUsatiGroup);
};

export const buildContrattiUsatiGroup = (fb: FormBuilder, item?: MyElContrattiUsati): FormGroup => {
    return fb.group({
        my_ContrattiUsatiDescNome: item?.my_ContrattiUsatiDescNome,
        my_ContrUsatiDesc: [item?.my_ContrUsatiDesc, CoopValidators.required],
        my_group12: item?.my_group12,
    });
};
